import * as React from "react";
import { Button } from "@fluentui/react-components";
import StringsStore from "sh-strings/store";

const styles = require("./PastScheduleListItem.scss");

// Icons from local assets
const shiftsActivityAvatar = require("../../../../../../assets/images/shifts-activity-avatar.svg");
const shiftsActivityIcon = require("../../../../../../assets/images/shifts-activity-icon.svg");

export interface PastScheduleListItemProps {
    dateRange: string;
    deletionInfo: string;
    daysUntilExpiry: number;
    onRestore: () => void;
    isFirstItem?: boolean;
    buttonRef?: React.RefObject<HTMLButtonElement>;
}

interface PastScheduleListItemState {
    isHovered: boolean;
}

/**
 * Individual past schedule item component for the Past Schedules dialog
 */
export default class PastScheduleListItem extends React.Component<PastScheduleListItemProps, PastScheduleListItemState> {
    private _strings: Map<string, string>;

    constructor(props: PastScheduleListItemProps) {
        super(props);
        this._strings = StringsStore().registeredStringModules.get("msTeamPicker").strings;
        this.state = {
            isHovered: false
        };
    }

    private handleMouseEnter = () => {
        this.setState({ isHovered: true });
    }

    private handleMouseLeave = () => {
        this.setState({ isHovered: false });
    }

    /**
     * Handle restore button click
     */
    private handleRestoreClick = () => {
        this.props.onRestore();
    }

    /**
     * Render the schedule avatar (Shifts Activity icon)
     */
    private renderScheduleAvatar(): JSX.Element {
        return (
            <div className={styles.scheduleAvatar} aria-hidden="true">
                <img src={shiftsActivityAvatar} alt="" className={styles.avatarBackground} />
                <img src={shiftsActivityIcon} alt="" className={styles.avatarIcon} />
            </div>
        );
    }

    render() {
        const { dateRange, deletionInfo, daysUntilExpiry, isFirstItem, buttonRef } = this.props;
        const expiryText = daysUntilExpiry === 1
            ? this._strings.get("daysUntilExpirySingular")
            : this._strings.get("daysUntilExpiryPlural").replace("{0}", String(daysUntilExpiry));

        // Action buttons (visible on hover)
        const actionButtons = this.state.isHovered ? (
            <div className={styles.scheduleActions}>
                <Button
                    ref={isFirstItem ? buttonRef : undefined}
                    appearance="outline"
                    onClick={this.handleRestoreClick}
                    aria-label={`Restore schedule ${dateRange}`}
                    data-automation-id={`restoreButton_${dateRange}`}
                    className={styles.restoreButton}
                >
                    Restore
                </Button>
            </div>
        ) : null;

        return (
            <div
                className={`${styles.scheduleListItem} ${this.state.isHovered ? styles.hovered : ""}`}
                role="listitem"
                aria-label={`${dateRange}. ${expiryText}. ${deletionInfo}`}
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
            >
                <div className={styles.scheduleInfo}>
                    {this.renderScheduleAvatar()}
                    <div className={styles.scheduleDetails}>
                        <div className={styles.dateRange}>{dateRange}</div>
                        <div className={styles.deletionInfo} title={`${expiryText} - ${deletionInfo}`}>
                            <span className={styles.expiryText}>{expiryText}</span>
                            <span> - {deletionInfo}</span>
                        </div>
                    </div>
                </div>
                {actionButtons}
            </div>
        );
    }
}
